import React from 'react';
import styles from '../../utils/styles/components/Header/style.module.css';

export const Header = ({ eyebrow, title, subtitle }) => {
  return (
    <div className={styles.header}>
      <span className={styles.eyebrow}>{eyebrow}</span>
      <div className={styles.copy}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};
